// Layout Types
export const CHANGE_LAYOUT = 'layout/CHANGE_LAYOUT';
export const CHANGE_LAYOUT_WIDTH = 'layout/CHANGE_LAYOUT_WIDTH';
export const CHANGE_SIDEBAR_THEME = 'layout/CHANGE_SIDEBAR_THEME';
export const CHANGE_BODY_THEME = 'layout/CHANGE_BODY_THEME';
export const CHANGE_SIDEBAR_TYPE = 'layout/CHANGE_SIDEBAR_TYPE';
export const CHANGE_BODY_MODE = 'layout/CHANGE_BODY_MODE';

// Topbar
export const CHANGE_TOPBAR_THEME = 'layout/CHANGE_TOPBAR_THEME';

// Sidebar
export const SHOW_SIDEBAR = 'layout/SHOW_SIDEBAR';
export const TOGGLE_LEFTMENU = 'layout/TOGGLE_LEFTMENU';

// Right Sidebar
export const SHOW_RIGHT_SIDEBAR = 'layout/SHOW_RIGHT_SIDEBAR';

// Reset State
export const RESET_LAYOUT_STATE = 'layout/RESET_LAYOUT_STATE';
